<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true
    }
  }
})
</script>

<template>
  <icon-clock v-if="name=== 'clock'" />
  <icon-map-pin v-else-if="name === 'map'"></icon-map-pin>
  <icon-world v-else-if="name === 'world'"></icon-world>
  <icon-passport v-else-if="name === 'passport'"></icon-passport>
  <icon-instagram v-else-if="name=== 'instagram'"></icon-instagram>
  <icon-facebook v-else-if="name=== 'facebook'"></icon-facebook>
  <icon-tiktok v-else-if="name=== 'tiktok'"></icon-tiktok>
  <icon-linkedin v-else-if="name=== 'linkedin'"></icon-linkedin>
  <icon-youtube v-else-if="name=== 'youtube'"></icon-youtube>
  <icon-trip-advisor v-else-if="name=== 'trip-advisor'"></icon-trip-advisor>
  <icon-xcom v-else-if="name=== 'xcom'"></icon-xcom>
  <icon-blog v-else-if="name=== 'blog'"></icon-blog>
  <icon-clock v-else />
</template>
